import React, { useEffect, useState } from 'react';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import CloseIcon from '../../../ui/svg/common/close';
import { IGdpr, isGdprOptOut, setGDPRCookie } from '../domain/gdpr-provider';
import { format } from 'date-fns';
import { getHiddenDataString, getIsAuthenticated } from '../../../domain/hidden-data-provider';
import { updateGDPR } from '../data/data-service';

const GA_EVENT_TITLE = 'Consent Widget';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-4435
 */
const GDPRWidgetLawyer = () => {

    const [classes, setClasses] = useState('');
    const [isShown, setIsShown] = useState(true);
    const isOptOut = isGdprOptOut();

    useEffect(() => {
        window.setTimeout(() => {
            setClasses('opened');
        }, 1);
    }, []);

    const readMoreGAEvent = () => {
        sendGAEvent(GA_EVENT_TITLE, 'Read More');
    };

    const customizeGAEvent = () => {
        sendGAEvent(GA_EVENT_TITLE, 'Customize');
    };

    const decline = async () => {
        const data: IGdpr = {
            IsMarketing: false,
            IsPerformance: false,
            ItemModifiedWhen: format(new Date(),'MM/dd/yyyy HH:mm:ss'),
            IsCountryGDPR: getHiddenDataString('gdpr-country') || 'u',
        };

        setGDPRCookie(data);

        const isUserLoggedIn = getIsAuthenticated();
        if(isUserLoggedIn) {
            await updateGDPR();
        }

        sendGAEvent(GA_EVENT_TITLE, 'I Decline');
        setIsShown(false);
    };

    const agree = async () => {

        const data: IGdpr = {
            IsMarketing: true,
            IsPerformance: true,
            ItemModifiedWhen: format(new Date(),'MM/dd/yyyy HH:mm:ss'),
            IsCountryGDPR: getHiddenDataString('gdpr-country') || 'u',
        };

        setGDPRCookie(data);

        const isUserLoggedIn = getIsAuthenticated();
        if(isUserLoggedIn) {
            await updateGDPR();
        }

        sendGAEvent(GA_EVENT_TITLE, 'I Agree');
        setIsShown(false);
    };

    const hide = () => {
        setIsShown(false);
    };

    return (
        <>
            {
                isShown &&
                <div id="slide-up-lawyer"
                     className={`fixed bottom-0 left-0 slide-up-lawyer max-w-full ${classes}`}
                     style={{
                         zIndex: 10002,
                         width: '600px',
                     }}>

                    <div
                        className="flex flex-col items-center justify-center text-center w-full py-6 px-4"
                        style={{
                            backgroundColor: '#EFFF00',
                            color: '#16151C'
                        }}>

                        <button
                            className="absolute right-0 top-0 mr-4 mt-4"
                            onClick={hide}
                            title="Close"
                            type="button">
                            <CloseIcon
                                width="15px"
                                color="#000"
                                title="Close"
                            />
                        </button>

                        <p className="waves-h3">Waves Cookie Consent</p>

                        {
                            isOptOut &&
                            <p>
                                We use cookies and similar technologies to enhance your browsing experience, serve
                                personalized ads
                                or content, and analyze our traffic.
                                By clicking "Accept All Cookies," you consent to our use of cookies as described in
                                our <a
                                href="/legal/cookie-policy" className="text-black" onClick={readMoreGAEvent}>Cookie
                                Policy</a>.
                            </p>
                        }

                        {
                            !isOptOut &&
                            <p>
                                We use cookies and similar technologies to enhance your browsing experience, serve personalized ads or content, and analyse our traffic, as described in our <a
                                href="/legal/cookie-policy" className="text-black" onClick={readMoreGAEvent}>Cookie
                                Policy</a>. You can opt-out of sharing your cookie data with third parties by clicking
                                “Essential Cookies Only”.
                            </p>
                        }

                        <div className="flex flex-col md:flex-row justify-center mt-4 mb-10">
                            <a
                                href="/legal/cookie-policy"
                                onClick={customizeGAEvent}
                                className="w-btn-outline-black bg-transparent md:mr-4 mb-2 md:mb-0">
                                Customize
                            </a>

                            <button
                                onClick={decline}
                                className="w-btn-outline-black bg-transparent md:mr-4 mb-2 md:mb-0"
                                type="button">
                                Essential Cookies Only
                            </button>

                            <button
                                onClick={agree}
                                className="w-btn bg-black"
                                type="button">
                                Accept All Cookies
                            </button>
                        </div>

                    </div>

                </div>
            }
        </>
    );
}

export default GDPRWidgetLawyer;